import request from '@/utils/request'

let AdApi = {
  /*列表*/
   adList(data, errorback) {
    return request._post('/shop/plus.ad.ad/index', data, errorback);
  },
  /*添加*/
  addAd(data, errorback) {
    return request._post('/shop/plus.ad.ad/add', data, errorback);
  },
  /*获取数据*/
  getAd(data, errorback) {
    return request._get('/shop/plus.ad.ad/edit', data, errorback);
  },
  /*保存*/
  saveAd(data, errorback) {
    console.log(data)
    return request._post('/shop/plus.ad.ad/edit', data, errorback);
  },
  /*删除*/
  delAd(data, errorback) {
    return request._post('/shop/plus.ad.ad/delete', data, errorback);
  },

}
export default AdApi;



// WEBPACK FOOTER //
// ./src/api/ad.js